import { Link } from "react-router-dom";
import "../styles/pagoResultado.css";

export default function PagoExitoso() {
  return (
    <div className="resultado-container">
      <div className="resultado-card exito">
        <div className="resultado-icon exito">✓</div>

        <h1>¡Pago realizado con éxito!</h1>

        <p className="resultado-texto">
          Tu inscripción ha sido confirmada correctamente.
        </p>

        <p className="resultado-subtexto">
          Hemos enviado un correo con todos los detalles del curso.<br />
          Recuerda conectarte al menos <b>5 minutos antes</b> del inicio de la clase.
        </p>

        <div className="resultado-actions">
          <Link to="/cursos" className="btn-primario">
            Ver más cursos
          </Link>

          <Link to="/" className="btn-secundario">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
